// namespace
export const PETS_NAMESPACE = 'pets'

// getters
export const PETS_GETTER = 'pets'
export const PETS_GETTER_PET_BY_ID = 'getPetById'

// mutations
export const PETS_MUTATION_ENTIRE_PETS = 'updateEntirePets'
export const PETS_MUTATION_SINGLE_PET = 'updateSinglePet'
export const PETS_MUTATION_SINGLE_PET_ATTRIBUTE = 'updateSinglePetAttribute'
export const PETS_MUTATION_DELETE_PET = 'deleteSinglePet'
export const PETS_MUTATION_ADD_PET = 'addPet'

// actions
export const PETS_ACTION_GET_PETS = 'fetchPets'
export const PETS_ACTION_CREATE_PET = 'createPet'
export const PETS_ACTION_DELETE_PET = 'deletePet'
export const PETS_ACTION_UPDATE_PET = 'updatePet'



// WEBPACK FOOTER //
// ./src/store/modules/pets-types.js